import { API_URL_ARTIST } from "@constants/env";
import { apiArtistToDto } from "@helpers/artist.helper";
import useApiCall from "@hooks/Shared/useApiCall";
import { IArtist } from "@interfaces/artist";

const useGetArtist = (uuid: string) =>
  useApiCall<IArtist>({
    url: API_URL_ARTIST + uuid,
    transformResponse: (data) =>
      apiArtistToDto(JSON.parse(data as string) as IArtist),
  });

export default useGetArtist;
